import { useEffect, useRef } from 'react';

const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'wheel'
];

export const useIdleLogout = ({ enabled = true, timeoutMs = 0, pause = false, onIdle }) => {
  const onIdleRef = useRef(onIdle);

  useEffect(() => {
    onIdleRef.current = onIdle;
  }, [onIdle]);

  useEffect(() => {
    if (!enabled || pause) return undefined;
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;
    if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) return undefined;

    let timerId;
    const resetTimer = () => {
      if (timerId) clearTimeout(timerId);
      timerId = setTimeout(() => {
        if (typeof onIdleRef.current === 'function') {
          onIdleRef.current();
        }
      }, timeoutMs);
    };

    const handleVisibility = () => {
      if (!document.hidden) resetTimer();
    };

    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, resetTimer, { passive: true });
    });
    document.addEventListener('visibilitychange', handleVisibility);

    resetTimer();

    return () => {
      if (timerId) clearTimeout(timerId);
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, resetTimer);
      });
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [enabled, pause, timeoutMs]);
};
